import React from 'react';
import './Keyboard.css';
import Logo from '../shell/Logo.png';
import { KeyboardMobileViewModel } from './KeyboardMobileViewModel';
import { SetupUIBindingForReactFunctionalComponent } from '../common/UIBinding';

let viewModel = new KeyboardMobileViewModel();
export function KeyboardMobile() {
    const contentRef = React.useRef(null);

    SetupUIBindingForReactFunctionalComponent(viewModel);

    React.useEffect(() => {
        viewModel.initialize();
        viewModel.scrollToEnd = () => {
            if (contentRef && contentRef.current) {
                contentRef.current.scrollTop = 99999;
            }
        };

        return () => {
            // Put some unmount logic here.
        };
    }, []);

    return <>
        {
            viewModel.isLoading ?
                <div>Loading...</div>
                : <>
                    {viewModel.uiLocation == 'main' ?
                        <div className="flex-v absolute keyboard-mobile content-padding">
                            <div className="flex-none header relative flex-h">
                                <div className="flex-auto"><img className="logo" src={Logo} /></div>
                                <div>
                                    {
                                        !viewModel.code ?
                                            <>
                                                <button onClick={() => viewModel.showKeyPad()}>Set Keyboard Code</button>
                                            </>
                                            : <>
                                                <span style={{ marginRight: '10px' }}>{viewModel.user.nickname}</span>
                                                <button onClick={() => viewModel.disconnect()}>Disconnect</button>
                                            </>
                                    }
                                </div>
                            </div>
                            {viewModel.code ?
                                <>
                                    <div className="flex-auto relative">
                                        <div ref={contentRef} className="keyboard-content absolute fulfill" dangerouslySetInnerHTML={{ __html: viewModel.displayContent }}></div>
                                    </div>
                                    <div className="flex-none flex-h toolbar">
                                        <button className="flex-auto" onClick={() => viewModel.switch()}>Switch</button>
                                        <button className="flex-auto" onClick={() => viewModel.delete()}>Delete</button>
                                        <button className="flex-auto" onClick={() => viewModel.type()}>Type</button>
                                        <button className="flex-auto" onClick={() => viewModel.enter()}>Enter</button>
                                    </div>
                                </>
                                : <div style={{ marginTop: '10px' }}>
                                    To get started, go to your desktop computer and visit <strong>https://typefast.azurewebsites.net</strong>, the website will help you setup.
                                    <p style={{textAlign:'center'}}><button className="flex-auto" onClick={() => viewModel.switch()}>Switch to other keyboard</button></p>
                                </div>}
                        </div>
                        : null}
                    {viewModel.uiLocation == 'keypad' ?
                        <div className="flex-v absolute keyboard-mobile content-padding">
                            <div className="relative display-code flex-h"><div><button className='back' onClick={() => viewModel.goBack()}>Back</button></div><div className="code-label">Code: </div><div className='code-content'>{viewModel.keyPadCode}</div></div>
                            <div className="flex-auto relative keypad">
                                <div className="absolute fulfill flex-v">
                                    <div className="flex-auto relative">
                                        <div className="absolute fulfill flex-h row">
                                            <div className="flex-auto relative"><button onClick={() => viewModel.typeKeyPad('1')}>1</button></div>
                                            <div className="flex-auto relative"><button onClick={() => viewModel.typeKeyPad('2')}>2</button></div>
                                            <div className="flex-auto relative"><button onClick={() => viewModel.typeKeyPad('3')}>3</button></div>
                                        </div>
                                    </div>
                                    <div className="flex-auto relative">
                                        <div className="absolute fulfill flex-h row">
                                            <div className="flex-auto relative"><button onClick={() => viewModel.typeKeyPad('4')}>4</button></div>
                                            <div className="flex-auto relative"><button onClick={() => viewModel.typeKeyPad('5')}>5</button></div>
                                            <div className="flex-auto relative"><button onClick={() => viewModel.typeKeyPad('6')}>6</button></div>
                                        </div>
                                    </div>
                                    <div className="flex-auto relative">
                                        <div className="absolute fulfill flex-h row">
                                            <div className="flex-auto relative"><button onClick={() => viewModel.typeKeyPad('7')}>7</button></div>
                                            <div className="flex-auto relative"><button onClick={() => viewModel.typeKeyPad('8')}>8</button></div>
                                            <div className="flex-auto relative"><button onClick={() => viewModel.typeKeyPad('9')}>9</button></div>
                                        </div>
                                    </div>
                                    <div className="flex-auto relative">
                                        <div className="absolute fulfill flex-h row">
                                            <div className="flex-auto relative"><button onClick={() => viewModel.clearKeyPad()}>Clear</button></div>
                                            <div className="flex-auto relative"><button onClick={() => viewModel.typeKeyPad('0')}>0</button></div>
                                            <div className="flex-auto relative"><button onClick={() => viewModel.submitKeyPad()}>OK</button></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null}
                </>
        }
    </>;
}

